// dependencies imports ⇒
import React, { useEffect, useState } from "react";
// assets and scss imports ⇒
import "./abhaDetailsViewContent.scss";
import editIcon from "../../../assets/editIcon.png";
import AbhaClinicRecords from "./AbhaClinicRecords";
import PrimaryButton from "../../common/Buttons/PrimaryButton";
import { c2cGetApiHandler } from "../../../Util/c2cApiHandler";
import { GET_PATIENT_ACCOUNT_LIST } from "../apiConstant";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import moment from "moment";
import { PROD } from "../../common/config";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaDetailsViewContent = (props) => {
  // const declarations ⇒
  const {
    abhaPatientDetails,
    handleShowConfirmationModal,
    handleAddNewPatient,
    handleBookAppointment,
    handleAbhaDetails,
  } = props;

  const [isEdited, setIsEdited] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");
  const [patientAccountList, setPatientAccountList] = useState([]);
  const [loader, setLoader] = useState(false);

  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  // let or var declarations ⇒

  // life cycle methods ⇒
  useEffect(() => {
    let abhaAddress = abhaPatientDetails?.abha_address
      ? abhaPatientDetails?.abha_address.split("@")[0]
      : "";
    let params = {
      patient_abha_address: abhaAddress, //abhaPatientDetails?.abha_address,
      phone_number: "",
    };
    getPatientAccountListApiCall(params);
  }, []);

  // API Calls ⇒

  const getPatientAccountListApiCall = (params) => {
    setLoader(true);
    const abhaPatientListResponse = c2cGetApiHandler(
      GET_PATIENT_ACCOUNT_LIST(clinicId),
      params
    );
    abhaPatientListResponse.then(([res, err]) => {
      if (!res?.data?.error && !err && res?.data?.statusCode === 200) {
        if (res?.data?.patient_data?.length > 0) {
          setPatientAccountList(res?.data?.patient_data);
        } else {
          setPatientAccountList([]);
        }
        setLoader(false);
      } else {
        setPatientAccountList([]);
        setLoader(false);
      }
    });
  };

  // Helper methods ⇒
  const getAgeToDisplay = (date) => {
    let startDate = moment(date, "YYYY-MM-DD");
    let endDate = moment();
    const duration = moment.duration(endDate.diff(startDate));

    return (
      `${duration.years() != "0" ? duration.years() + " Years " : ""}` +
      `${duration.months() != "0" ? duration.months() + " Months " : ""}` +
      `${duration.days() != "0" ? duration.days() + " Days " : ""}`
    );
  };

  const getDobAndAge = (date) => {
    if (date) {
      return moment(date).format("DD MMM YYYY") + "/" + getAgeToDisplay(date);
    }
  };

  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  // Actions ⇒

  const handleOpenEdit = () => {
    setPhoneInput(abhaPatientDetails?.phone_number);
    setIsEdited(true);
  };

  const handleCloseEdit = () => {
    setIsEdited(false);
  };

  const handleSearch = () => {
    if (phoneInput?.length === 10) {
      handleAbhaDetails(phoneInput);
      let params = {
        phone_number: "+91" + phoneInput,
      };
      getPatientAccountListApiCall(params);
      handleCloseEdit();
    }
  };

  const handleOnChange = (e) => {
    let value = e.target.value;
    if (value?.length <= 10) {
      setPhoneInput(value);
    }
  };

  const handleInputKeydown = (e) => {
    (e.key?.toLowerCase() === "e" ||
      e.key === "+" ||
      e.key === "-" ||
      e.key === "." ||
      e.key === "ArrowUp" ||
      e.key === "ArrowDown") &&
      e.preventDefault();
  };

  // create UI ⇒

  const abhaPatientDetailsField = (label, value, className) => {
    return (
      <div
        className={"advc-label-value-container " + (className ? className : "")}
      >
        <div className="advc-label">{label}</div>
        <div className="advc-value">{value ? value : "-"}</div>
      </div>
    );
  };

  const abhaPatientDetailsMobileField = (value) => {
    return (
      <div className="advc-mobile-field-container">
        <div className="advc-label">Phone Number</div>
        {!isEdited ? (
          <div className="advc-edit-value-container">
            <div className="advc-value">{value ? value : "-"}</div>
            <div className="advc-phone-edit">
              <img
                src={editIcon}
                alt=""
                onClick={handleOpenEdit}
                className="advc-edit-icon"
              />
            </div>
          </div>
        ) : (
          <div className="advc-edit-phone-container">
            <div className="advc-phone-input-container">
              <div className="advc-phone-prefix">+91</div>
              <div className="advc-phone-input">
                <input
                  type="number"
                  value={phoneInput}
                  onChange={handleOnChange}
                  onKeyDown={handleInputKeydown}
                />
              </div>
            </div>
            <div className="advc-search-btn-container">
              <PrimaryButton title="Search" handleButtonClick={handleSearch} />
            </div>
          </div>
        )}
      </div>
    );
  };

  const abhaPatientDetailsUI = () => {
    return (
      <div className="advc-container">
        <div className="advc-heading">Details</div>
        <div className="advc-patient-details-container">
          <div className="advc-patient-details--wrapper">
            {abhaPatientDetailsField(
              "Patient Name",
              abhaPatientDetails?.name,
              "advc-patient-details-full-width"
            )}
            {abhaPatientDetailsField(
              "Date of Birth/Age",
              getDobAndAge(abhaPatientDetails?.dob),
              "advc-patient-details-full-width"
            )}
            {abhaPatientDetailsField(
              "Gender",
              abhaPatientDetails?.gender,
              "advc-patient-details-half-width"
            )}
            {abhaPatientDetailsField(
              "ABHA Address",
              abhaPatientDetails?.abha_address
                ? getAbhaAddress(abhaPatientDetails?.abha_address)
                : "",
              "advc-patient-details-half-width"
            )}
          </div>
          {abhaPatientDetailsMobileField(abhaPatientDetails?.phone_number)}
        </div>
      </div>
    );
  };
  const abhaPatientListUI = () => {
    return (
      <>
        <AbhaClinicRecords
          patientAccountList={patientAccountList}
          handleShowConfirmationModal={handleShowConfirmationModal}
          handleAddNewPatient={handleAddNewPatient}
          handleBookAppointment={handleBookAppointment}
          loader={loader}
        />
      </>
    );
  };
  return (
    <div className="abha-details-view-content">
      {abhaPatientDetailsUI()}
      {abhaPatientListUI()}
    </div>
  );
};

// export ⇒

export default AbhaDetailsViewContent;
